import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const LoginForm = () => {
  const [password, setPassword] = useState('');
  const { setCredentials } = useAuth();
  const [username, setUsername] = useState('user');
  const [showUsernameInput, setShowUsernameInput] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCredentials(username, password);
  };

  const toggleUsernameInput = (e) => {
    e.preventDefault(); // Prevent the default link behavior
    setShowUsernameInput(!showUsernameInput);
  };

  return (
      <div className="login-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Pixotope Cloud Downloader</h2>
          <div className="form-group">
            {showUsernameInput ? (
                <>
                  <label>username:</label>
                  <input
                      type="text"
                      id="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      className="form-input"
                  />
                </>
            ) : (
                <div>
                  You are authenticating as a <a href="#" onClick={toggleUsernameInput} className="change-link">regular user</a>.
                </div>
            )}
          </div>
          <div className="form-group">
            <label>password:</label>
            <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
            />
          </div>
          <button type="submit" className="login-button">Login</button>
        </form>
      </div>
  );
};

export default LoginForm;
